import '.ax{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.hl{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a9{justify-content:center;}.ssr-plugin'
import '.al{align-items:flex-start;}.ssr-plugin'
import '.dr{padding:2rem;}.ssr-plugin'
import '.d6{background:var(--palette-white);}.ssr-plugin'
import '.as{overflow:hidden;}.ssr-plugin'
import '.bf{position:absolute;}.ssr-plugin'
import '.jb{top:50%;}.ssr-plugin'
import '.jc{right:1rem;}.ssr-plugin'
import '.jd{transform:translateY(-50%);}.ssr-plugin'
import '.je{width:120px;}.ssr-plugin'
import '.jf{height:120px;}.ssr-plugin'
import '.jg{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ik{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jh{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ax n hl d e a9 al dr d6 as"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bf jb jc jd je jf jg d r a9"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ax ik d e al s jh"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
